import { useI18n } from '../i18n/I18nProvider'

function Terms() {
  const { t } = useI18n()
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-8">
        <h1 className="text-4xl font-bold text-green-800 mb-8">
          {t('terms.title')}
        </h1>

        <div className="prose prose-green max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('terms.acceptance.title')}</h2>
            <p>
              {t('terms.acceptance.content')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('terms.serviceDescription.title')}</h2>
            <p>
              {t('terms.serviceDescription.content')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('terms.userAccount.title')}</h2>
            <p>
              {t('terms.userAccount.content')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('terms.subscriptions.title')}</h2>
            <p>
              {t('terms.subscriptions.content')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('terms.intellectualProperty.title')}</h2>
            <p>
              {t('terms.intellectualProperty.content')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('terms.userConduct.title')}</h2>
            <p>
              {t('terms.userConduct.content')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('terms.liability.title')}</h2>
            <p>
              {t('terms.liability.content')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('terms.modifications.title')}</h2>
            <p>
              {t('terms.modifications.content')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('terms.contact.title')}</h2>
            <p>
              {t('terms.contact.content')}
            </p>
          </section>

          <p className="text-sm text-gray-500 mt-8">
            {t('terms.lastUpdated', { date: new Date().toLocaleDateString(t('terms.localeCode') || 'fr-FR') })}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Terms
